import { gql } from "lib/apolloClient";
import { assessmentToolFragment } from "modules/AssessmentTool/AssessmentToolFragment";
import { toolResponseFragment } from "modules/CommonFragments";

export const getAIAnalysisScaleDetailsQuery = gql`
  query getAIAnalysisScaleDetails($id: ID!) {
    node(id: $id, type: ASSESSMENT) {
      id
      ... on Assessment {
        id
        aiConversation {
          edges {
            node {
              id
              entitySubType
              metadata
              messages {
                edges {
                  node {
                    id
                    metadata
                  }
                }
              }
            }
          }
        }
        assessmentTools {
          edges {
            node {
              id
              assessmentToolType
              assessmentToolItem {
                id
                ... on Analysis {
                  ...aiAnalysisItem
                }
              }
            }
          }
        }
      }
    }
  }
  ${assessmentToolFragment.aiAnalysis}
`;

export const getAIAnalysisScaleEvaluationQuery = gql`
  query getAIAnalysisScaleEvaluation($id: ID!) {
    node(id: $id, type: AI_CONVERSATION) {
      ... on AiConversation {
        id
        entityType
        metadata
        messages {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              authorType
              content
              parentMessage {
                id
              }
              metadata
              attachments {
                id
              }
            }
          }
        }
        analysisToolEvaluation(filters: { userFilter: ALL }) {
          id
          toolId
          toolType
          toolResponses {
            ...toolResponseItem
          }
        }
      }
    }
  }
  ${toolResponseFragment.toolResponse}
`;
